import { useState } from "react";
import "./App.css";
import Map from "./components/map";
import { AppBar, Backdrop, Box, Button, Container, Divider, Drawer, Fade, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Switch, Toolbar, Typography, Unstable_TrapFocus as UnstableTrapFocus } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import EmailIcon from '@mui/icons-material/Email';
import { Link } from "react-router";
import { IconPinBakery, IconPinCafe, IconPinCraft, IconPinFleaMarket, IconPinGarden, IconPinMulti, IconPinShopClothes, IconPinShopFood, IconPinShopInteriorDesign } from "./icons";
import { CONTACT_EMAIL } from "./constants";
import logo from "./logo.png";
import CloseIcon from '@mui/icons-material/Close';
import IosShareIcon from '@mui/icons-material/IosShare';
import { isAndroid, isIOS } from "react-device-detect";

let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [itemFilter, setItemFilter] = useState({
    shopFood: true,
    shopInteriorDesign: true,
    accommodations: true,
    cafe: true,
    garden: true,
    craft: true,
    fleaMarket: true,
    bakery: true
  });

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawerWidth = 300;

  const handleSwitchChange = (name) => {
    setItemFilter({
      ...itemFilter,
      [name]: !itemFilter[name]
    });
  };

  const drawer = () => {
    return (
      <>
        <Toolbar />
        <Divider />
        <List dense sx={{ height: "100%" }}>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("cafe")}>
              <ListItemIcon>
                <IconPinCafe />
              </ListItemIcon>
              <ListItemText primary="Gastronomiska Pärlor" />
              <Switch edge="end" checked={itemFilter.cafe} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("shopFood")}>
              <ListItemIcon>
                <IconPinShopFood />
              </ListItemIcon>
              <ListItemText primary="Gårdsbutik Livsmedel" />
              <Switch edge="end" checked={itemFilter.shopFood} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("shopInteriorDesign")}>
              <ListItemIcon>
                <IconPinShopInteriorDesign />
              </ListItemIcon>
              <ListItemText primary="Gårdsbutik Inredning" />
              <Switch edge="end" checked={itemFilter.shopInteriorDesign} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("accommodations")}>
              <ListItemIcon>
                <IconPinShopClothes />
              </ListItemIcon>
              <ListItemText primary="Unika boenden" />
              <Switch edge="end" checked={itemFilter.accommodations} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("garden")}>
              <ListItemIcon>
                <IconPinGarden />
              </ListItemIcon>
              <ListItemText primary="Trädgård/Odling" />
              <Switch edge="end" checked={itemFilter.garden} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("craft")}>
              <ListItemIcon>
                <IconPinCraft />
              </ListItemIcon>
              <ListItemText primary="Hantverk/Konst" />
              <Switch edge="end" checked={itemFilter.craft} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("fleaMarket")}>
              <ListItemIcon>
                <IconPinFleaMarket />
              </ListItemIcon>
              <ListItemText primary="Loppis/Secondhand" />
              <Switch edge="end" checked={itemFilter.fleaMarket} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleSwitchChange("bakery")}>
              <ListItemIcon>
                <IconPinBakery />
              </ListItemIcon>
              <ListItemText primary="Gårdsbageri" />
              <Switch edge="end" checked={itemFilter.bakery} />
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <IconPinMulti />
            </ListItemIcon>
            <ListItemText primary="Fler än en kategori" />
          </ListItem>

          <ListItem disablePadding sx={{
            position: "absolute",
            bottom: 0
          }}>
            <ListItemButton
              target="_top"
              rel="noopener noreferrer"
              href={`mailto:${CONTACT_EMAIL}`}>
              <ListItemIcon>
                <EmailIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Kontakta oss" />
            </ListItemButton>
          </ListItem>
        </List>
        <Container sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
          <Typography variant="caption" sx={{ color: "#c4b397" }}>
            &copy; 2025 lokalaparlor.com
          </Typography>
        </Container>
      </>
    )
  };

  const [bannerOpen, setBannerOpen] = useState(true);
  const closeBanner = () => {
    setBannerOpen(false);
  };

  const installContent = () => {
    if (isIOS) {
      return (
        <Box>
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <Typography variant="subtitle1">1. Tryck på </Typography>
            <IosShareIcon fontSize="small" />
          </Box>
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <Typography variant="subtitle1">2. Välj</Typography>
            <Typography variant="caption">"Lägg till på hemskärmen"</Typography>
          </Box>
        </Box >
      )
    }

    const installClick = () => {
      deferredPrompt.prompt();
      setBannerOpen(false);
    }

    return (
      <Box sx={{ display: "flex", justifyContent: "center", height: "42px" }}>
        <Button variant="contained" onClick={installClick}>Installera</Button>
      </Box>
    )
  }

  const showInstall = () => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      return <></>
    }

    if (isIOS || (isAndroid && deferredPrompt !== undefined)) {
      return (<>
        <Backdrop
          open={bannerOpen}
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          onClick={closeBanner} />
        <UnstableTrapFocus>
          <Fade appear={false} in={bannerOpen}>
            <Paper
              role="dialog"
              aria-modal="false"
              aria-label="Install banner"
              square
              variant="outlined"
              tabIndex={-1}
              sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                m: "0 8px 8px 8px",
                p: 2,
                borderWidth: 0,
                borderTopWidth: 1,
                zIndex: 2000,
                borderRadius: "14px"
              }}
            >
              <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "8px"
              }}>

                <Typography
                  variant="subtitle1"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px"
                  }}>
                  <Box
                    component="img"
                    sx={{ height: 38, borderRadius: "8px" }}
                    alt="Logo"
                    src={logo}
                  />Installera Lokala Pärlor</Typography>
                <IconButton onClick={closeBanner}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Divider />
              <Typography sx={{ paddingTop: "18px", paddingBottom: "8px" }}>Installera vår app och upptäck dina lokala pärlor nära dig!</Typography>
              {installContent()}
            </Paper>
          </Fade>
        </UnstableTrapFocus>
      </>)
    }
    return <></>;
  }

  return (
    <div id="app-main">
      <AppBar className="appbar" position="static" color="primary" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} >
        <Toolbar sx={{ paddingLeft: { sm: 0 } }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={handleDrawerToggle}
            aria-label="open drawer"
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Link className="header-logo" to="/">
            <Box
              component="img"
              sx={{ height: 54 }}
              alt="Logo"
              src={logo}
            />
            <Typography
              variant="title"
              color="inherit"
              sx={{ textDecoration: "none" }}>
              Lokala Pärlor
            </Typography>
          </Link>
        </Toolbar>
      </AppBar >
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
          }}
        >
          {drawer()}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
          open
        >
          {drawer()}
        </Drawer>
      </nav>

      <Container component={"main"} className="main" disableGutters maxWidth={false}>
        <Map filter={itemFilter} />
      </Container>

      {showInstall()}
    </div >
  );
}

export default App;
